import { camelCase } from 'lodash';

export const mapKeysToCamelCase = (obj: any): any => {
  return Object.keys(obj).reduce((acc, key) => {
    acc[camelCase(key)] = obj[key];
    
    return acc;
  }, {});
};